export const EN = 'en';
export const LV = 'lv';
export const RU = 'ru';

export const ALL_LOCALES = [
	EN,
	LV,
	RU,
];